<template>
  <div>
    <b-modal
      id='algolia-search-modal'
      :title="trans('search')"
      hide-footer
      size="lg"
      @shown="onShown"
    >
      <algolia-search
        ref="algolia"
        :organization="organization"
        btn-variant="branded"
        :block="block"
        :page="page"
      ></algolia-search>

      <p class="text-right" v-if="showChatGpt">
        <b-button
          variant="link"
          size="sm"
          class="text-branded"
          @click="onClickChatGpt"
        >
          <i class="fa fa-fw fa-robot"></i>
          {{ trans('ask_chat_gpt') }}
        </b-button>
      </p>
    </b-modal>
    <ai-assistant-modal
      :initial-message="chat_gpt_initial_message"
      :organization="organization"
    ></ai-assistant-modal>
  </div>
</template>


<script>
  import AlgoliaSearch from './../help/AlgoliaSearch'
  import AiAssistantModal from './../microsite/AiAssistantModal'

  export default {
    props: {
      organization: Object,
      block: Object, // Can be null
      page: Object, // Can be null
    },
    components: {
      AlgoliaSearch,
      AiAssistantModal,
    },
    data() {
      return {
        trans: trans,
        chat_gpt_initial_message: null,
      }
    },
    computed: {
      showChatGpt() {
        return [5, 2754, 1093].indexOf(this.organization.id) >= 0
      },
    },
    methods: {
      onShown() {
        this.chat_gpt_initial_message = null
      },
      onClickChatGpt() {
        this.chat_gpt_initial_message = this.$refs.algolia.getInputValue()
        this.$bvModal.show('ai-assistant-modal')
        this.$bvModal.hide('algolia-search-modal')
      },
    },
    mounted() {
      window.algoliaSearchModal = this
    },
  }
</script>